import React, { Component } from "react";
import { connect } from "react-redux";
import * as baseActions from "../redux/modules/base";

import Header from "../components/header";
import Body from "../components/main/body_main";
import Section2Banner from "../components/section2-banner/section2";
import Footer from "../components/footer/footer_dark";

class Main extends Component {
  render() {
    return (
      <div>
        <Header />
        <Body />
        <Section2Banner />
        <Footer />
      </div>
    );
  }
}

export default Main;
